import React from 'react';
import { Container } from './ui/Container';
import { Button } from './ui/Button';
import { Check, ShieldCheck } from 'lucide-react';
export function WelcomeSection() {
  const trustBadges = [{
    label: 'Kukkiwon',
    sublabel: 'Affiliated School'
  }, {
    label: 'WTF',
    sublabel: 'World Taekwondo Federation'
  }, {
    label: 'USNTF',
    sublabel: 'US National TKD Federation'
  }, {
    label: 'ITSO',
    sublabel: 'Illinois TKD State Org.'
  }];
  return <section className="py-20 bg-bg" data-id="element-467">
      <Container data-id="element-468">
        <div className="flex flex-col lg:flex-row gap-12 lg:gap-20" data-id="element-469">
          {/* Text Content */}
          <div className="flex-1" data-id="element-470">
            <h2 className="text-3xl md:text-4xl font-extrabold text-nav mb-6 uppercase tracking-tight font-heading" data-id="element-471">
              Why Train Here?
            </h2>
            <div className="w-20 h-1 bg-accent mb-8" data-id="element-472"></div>

            <div className="space-y-6 text-gray-600 leading-relaxed text-lg mb-8" data-id="element-473">
              <p data-id="element-474">
                Dragon Martial Arts of Round Lake, located in Round Lake, IL is
                a Kukkiwon affiliated school offering a wide variety of classes
                appealing to all age groups and skill sets.
              </p>
              <p data-id="element-475">
                We welcome not only new students, but also returning students of
                all ages… there is something for everyone here at Dragon Martial
                Arts of Round Lake.
              </p>
            </div>

            <ul className="space-y-4 mb-10" data-id="element-476">
              <BenefitItem text="Wide variety of classes for all ages & skill levels" data-id="element-477" />
              <BenefitItem text="Curriculum includes speed/agility, cardio workouts" data-id="element-478" />
              <BenefitItem text="Training in self defense, forms, and sparring" data-id="element-479" />
              <BenefitItem text="Proud member of WTF, USNTF, ITSO" data-id="element-480" />
            </ul>

            {/* Trust Badges */}
            <div className="grid grid-cols-2 sm:grid-cols-4 gap-3 mb-10" data-id="element-481">
              {trustBadges.map(badge => <div key={badge.label} className="flex flex-col items-center text-center bg-white border border-gray-200 rounded-lg px-3 py-4 shadow-sm" data-id="element-482">
                  <ShieldCheck className="w-6 h-6 text-accent mb-2" aria-hidden="true" data-id="element-483" />
                  <span className="font-extrabold text-nav font-heading text-lg leading-none" data-id="element-484">
                    {badge.label}
                  </span>
                  <span className="text-xs text-gray-500 mt-1 leading-tight" data-id="element-485">
                    {badge.sublabel}
                  </span>
                </div>)}
            </div>

            <div className="flex flex-col sm:flex-row gap-4" data-id="element-486">
              <a href="#signup" data-id="element-487">
                <Button variant="primary" size="lg" data-id="element-488">
                  Get One Week Free Trial
                </Button>
              </a>
              <a href="tel:8472128045" data-id="element-489">
                <Button variant="default" size="lg" data-id="element-490">
                  Call (847) 212-8045
                </Button>
              </a>
            </div>
          </div>

          {/* School Info Card */}
          <div className="lg:w-1/3" data-id="element-491">
            <div className="bg-white p-8 rounded-lg shadow-xl border-t-4 border-accent h-full" data-id="element-492">
              <h3 className="text-xl font-bold text-nav mb-6 font-heading uppercase" data-id="element-493">
                School Info
              </h3>

              <div className="space-y-6" data-id="element-494">
                <div data-id="element-495">
                  <h4 className="font-bold text-gray-900 mb-1" data-id="element-496">
                    Dragon Martial Arts of Round Lake
                  </h4>
                  <p className="text-gray-600" data-id="element-497">
                    655 Railroad Ave.
                    <br data-id="element-498" />
                    Round Lake, IL 60073
                  </p>
                </div>

                <div data-id="element-499">
                  <h4 className="font-bold text-gray-900 mb-1" data-id="element-500">Phone</h4>
                  <a href="tel:8472128045" className="text-link font-bold hover:text-accent" data-id="element-501">
                    (847) 212-8045
                  </a>
                </div>

                <div data-id="element-502">
                  <h4 className="font-bold text-gray-900 mb-1" data-id="element-503">Hours</h4>
                  <p className="text-gray-600 text-sm" data-id="element-504">
                    Mon–Fri: 3:00 pm – 8:00 pm
                    <br data-id="element-505" />
                    Sat: 9:00 am – 1:00 pm
                    <br data-id="element-506" />
                    Sun: Closed
                  </p>
                </div>

                <div className="pt-4" data-id="element-507">
                  <img src="https://dragonmartialarts-rl.com/wp-content/uploads/2018/12/DragonMartialArts-Logo-UNDER-NAV-150x150.png" alt="Dragon Martial Arts of Round Lake logo" className="w-24 h-24 mx-auto opacity-80" data-id="element-508" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </Container>
    </section>;
}
function BenefitItem({
  text
}: {
  text: string;
}) {
  return <li className="flex items-start" data-id="element-509">
      <div className="bg-accent/10 p-1 rounded-full mr-3 mt-1" data-id="element-510">
        <Check className="w-4 h-4 text-accent" aria-hidden="true" data-id="element-511" />
      </div>
      <span className="text-gray-700 font-medium" data-id="element-512">{text}</span>
    </li>;
}